module.exports = __webpack_public_path__ + "media/images/Grouping-57fce0adf24f0909e254eb8a22f13809.png";